module.exports = __webpack_public_path__ + "img/Biometric.d037a514.svg";